export default __webpack_public_path__ + "static/2-e24c358ccf1b3db9a6adf24fbd347132.jpeg";